import { authHeader } from '../_helpers';

export const reportsService = {
    getAll,
    getDash,
    get,
    getRoles,
    post,
    password
};

function post(name, email, role, password) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'POST',
            headers: token,
            body: JSON.stringify({name, email, role, password})
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/reports`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function getAll() {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'GET',
            headers: token
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/reports`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function getDash() {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'GET',
            headers: token
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/reports/dash`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function get(id) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'GET',
            headers: token
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/reports/${id}`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
    })
}

function password(password) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'POST',
            headers: token,
            body: JSON.stringify({password})
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/password`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function getRoles() {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'GET',
            headers: token
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/roles`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
    })
}